import { ITestCase } from "./ITestCase";
import { getGarconUrl, randomString, } from "../Utils";
import { checkGarconUrl, checkTicket, tryFetchTicket, connectSignalling, } from "./Utils";
import { Features, Services } from "./Modules";
import { KaldunTicketsClient } from "../generated/submodules/garcon-api/TicketsServiceClientPb";
import KaldunTicketSubject from "../client/TicketSubject";
import RoomSession from "../client/RoomSession";
import { IcePolicy } from "../client/Domain";
import * as rx from 'rxjs'

export default class LivePartyWithIceRestart implements ITestCase {
    readonly tags: Set<string> = new Set([
        Features.LiveParty,
        Services.Garcon,
        Services.Kvashanina,
        Services.Kaldun,
        Services.Mediasoup,
    ]);

    get name(): string {
        return "LivePartyWithIceRestart"
    }

    async callback(assert: Assert): Promise<void> {
        const garconUrl = checkGarconUrl(assert, await getGarconUrl());

        const client = new KaldunTicketsClient(garconUrl);

        const user = {
            accountId: randomString(),
            clientId: randomString(),
            roomId: randomString(),
        };

        const ticket = await tryFetchTicket(client, {
            ...user,
            subject: KaldunTicketSubject.BroadcastAndView,
        });

        checkTicket(assert, {
            ticket: ticket?.getTicket(),
            ...user,
            subject: KaldunTicketSubject.BroadcastAndView
        });

        if (!ticket) {
            return;
        }

        const signalling = await connectSignalling(assert, ticket.getEndpoint(), user, KaldunTicketSubject.BroadcastAndView);
        if (!signalling) {
            return;
        }
    
        const session = new RoomSession({
            roomId: user.roomId,
            icePolicy: IcePolicy.All,
            enableScreenShare: false,
            ticketSubject: KaldunTicketSubject.BroadcastAndView,
            iceServers: [],
            maxCameraSendFrameRate: null,
            maxCameraSendBitrate: null,
        });

        const offer = await session.createInitialOffer();
        const joinResult = await signalling.join({
            offer,
            allowAutomaticSimulcast: false
        });

        assert.true("join_room_v2" in joinResult, `User joined to room = ${user.roomId}`);
    
        if ("join_room_v2" in joinResult) {
            assert.true(await session.applyProducedSdpOffer(joinResult.join_room_v2.sdp_offer), `Applied produced sdp offer in room = ${user.roomId}`);
            assert.true(await session.applyProducedSdpAnswer(joinResult.join_room_v2.sdp_answer), `Aplied produced sdp answer in room = ${user.roomId}`);
        };

        const notificationPromise = rx.firstValueFrom(signalling.roomUpdatedNotification.pipe(rx.timeout(5000)));

        const restartIceResult = await signalling.restartIce();
        assert.true("restart_ice" in restartIceResult, "ICE restart succeded");

        const notificatoin = await notificationPromise;
        assert.true("consumed_media_sdp_offer" in notificatoin.room_updated, "Room updated notification has sdp offer");

        const leaveResult = await signalling.leave();
        assert.true("leave_room" in leaveResult, `User leaved from room = ${user.roomId}`);
        await session.terminate();
    }
}
